export default function () {
  return {
    newsTexts: [],
  };
}
